import Phaser from "phaser";
import type { PlatformAdapter } from "./adapters/PlatformAdapter";
import { TelegramAdapter } from "./adapters/TelegramAdapter";
import { WebAdapter } from "./adapters/WebAdapter";
import { BootScene } from "./core/scenes/BootScene";
import { MenuScene } from "./core/scenes/MenuScene";
import { GameScene } from "./core/scenes/GameScene";
import { UIScene } from "./core/scenes/UIScene";
import { GameOverScene } from "./core/scenes/GameOverScene";

async function pickAdapter(): Promise<PlatformAdapter> {
  if (TelegramAdapter.isAvailable()) {
    const tg = new TelegramAdapter();
    await tg.init();
    return tg;
  }
  const web = new WebAdapter();
  await web.init();
  return web;
}

// Fixed logical resolution. Phaser Scale.FIT scales this into any viewport.
const LOGICAL_WIDTH = 480;
const LOGICAL_HEIGHT = 854;

async function main(): Promise<void> {
  const adapter = await pickAdapter();

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: "game",
    backgroundColor: "#0b1020",
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: LOGICAL_WIDTH,
      height: LOGICAL_HEIGHT,
    },
    scene: [BootScene, MenuScene, GameScene, UIScene, GameOverScene],
    fps: { target: 60, smoothStep: true },
  });

  game.registry.set("adapter", adapter);
  // Save adapter reference for debugging in DevTools.
  (window as unknown as { td: { adapter: PlatformAdapter; game: Phaser.Game } }).td = {
    adapter,
    game,
  };

  console.log(`[TD] booted on ${adapter.name}`);
}

main().catch((err) => {
  console.error("[TD] fatal", err);
  document.body.innerHTML = `<pre style="color:#f66;padding:24px;font-family:monospace">${String(err?.stack ?? err)}</pre>`;
});
